import { useEffect, ComponentType } from "react";
import { useShallow } from "zustand/react/shallow";

import useCommandPaletteStore from "components/CommandPalette/store/useCommandPaletteStore";
import useCommandPaletteBuckets from "components/CommandPalette/config/useBuckets";
import useCommandPaletteScrollToActive from "components/CommandPalette/hooks/useScrollToActive";
import { SUB_LIST_VIEWS, SubListViewKey } from "components/CommandPalette/constants";
import { selectActiveActionId } from "components/CommandPalette/store/useCommandPaletteStore/selectors";

import CommandPaletteMainListView from "../MainListView";
import CommandPaletteSubListViewStacksSearch from "../../subListViews/StacksSearch";
import CommandPaletteSubListViewModulesSearch from "../../subListViews/ModulesSearch";
import CommandPaletteSubListViewPoliciesSearch from "../../subListViews/PoliciesSearch";
import CommandPaletteSubListViewContextsSearch from "../../subListViews/ContextsSearch";

const SUB_LIST_VIEW_COMPONENTS: Record<SubListViewKey, ComponentType> = {
  [SUB_LIST_VIEWS.STACKS_SEARCH]: CommandPaletteSubListViewStacksSearch,
  [SUB_LIST_VIEWS.MODULES_SEARCH]: CommandPaletteSubListViewModulesSearch,
  [SUB_LIST_VIEWS.POLICIES_SEARCH]: CommandPaletteSubListViewPoliciesSearch,
  [SUB_LIST_VIEWS.CONTEXTS_SEARCH]: CommandPaletteSubListViewContextsSearch,
};

const CommandPaletteContent = () => {
  const { currentView, subListView, setBuckets, activeActionId, activeActionSource } =
    useCommandPaletteStore(
      useShallow((state) => ({
        currentView: state.currentView,
        subListView: state.subListView,
        setBuckets: state.setBuckets,
        activeActionId: selectActiveActionId(state),
        activeActionSource: state.activeActionSource,
      }))
    );

  const buckets = useCommandPaletteBuckets();

  useCommandPaletteScrollToActive(activeActionId, activeActionSource);

  useEffect(() => {
    setBuckets(buckets);
  }, [buckets, setBuckets]);

  if (currentView === "sub-list" && subListView) {
    const SubListComponent = SUB_LIST_VIEW_COMPONENTS[subListView as SubListViewKey];
    return SubListComponent ? (
      <SubListComponent />
    ) : (
      <CommandPaletteMainListView buckets={buckets} />
    );
  }

  return <CommandPaletteMainListView buckets={buckets} />;
};

export default CommandPaletteContent;
